<script setup lang="ts">
const { evento } = defineProps<{ evento: any }>();
</script>

<template>
  <article
    class="group relative overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition hover:shadow-md"
  >
    <div class="flex h-64 flex-col p-5">
      <div class="h-32">
        <div class="flex items-start justify-between gap-3">
          <h3
            class="line-clamp-2 text-lg font-semibold text-gray-900 group-hover:text-teal-600"
            data-testid="descripcion-evento"
          >
            {{ evento.nombre }}
          </h3>
          <div class="flex shrink-0 flex-col items-end gap-1">
            <span
              class="rounded-full bg-teal-50 px-3 py-1 text-xs font-medium text-teal-700"
              data-testid="fecha-hora-evento"
            >
              {{ evento.fecha }} · {{ evento.hora }}
            </span>
            <span class="px-3 text-xs text-gray-600"
              >{{ evento.cantidadInscritos }} usuarios inscritos</span
            >
          </div>
        </div>

        <div class="mt-2">
          <span
            v-if="evento.registrado"
            class="rounded-full bg-green-50 px-2.5 py-0.5 text-xs font-medium text-green-700"
            >Registrado</span
          >
          <img
            v-if="evento.logo"
            :src="evento.logo"
            alt="logo"
            style="background-color: #000000; width: 70px; height: 70px"
          />
        </div>
      </div>
      <p class="line-clamp-2 min-h-[2.5rem] text-sm text-gray-600">
        Dirección:
        <span class="font-medium text-gray-900" data-testid="direccion-evento">{{
          evento.direccion || evento.direccionActividad
        }}</span>
      </p>

      <router-link
        :to="`/eventos/${evento.id}`"
        class="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-teal-600 px-3 py-2 text-center text-sm font-medium text-white transition hover:bg-teal-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
      >
        Ver detalles
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          class="h-4 w-4"
        >
          <path
            fill-rule="evenodd"
            d="M10.293 3.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L13.586 10H4a1 1 0 110-2h9.586l-3.293-3.293a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </router-link>
    </div>
  </article>
</template>

<style scoped></style>
